import {
  COMMAND_LOG_SET_ACTIVE_INDEX,
  COMMAND_LOG_SET_VISUAL_DATA,
  NETWORK_LOG_SET_ACTIVE_INDEX,
  SET_ACTIVE_TAB,
  SET_SCREENSHOT_URL_FOR_VIDEO,
  SET_LAST_PLAYED_SECOND,
  SET_VIDEO_URL,
  SET_CHANGE_FROM_VIDEO_COMP,
  SET_IS_VIDEO_PLAYABLE,
  SET_IS_VIDEO_PLAYING,
} from '../../actionTypeConstants/ml2.0/VideoLogsSync';

const initialState = {
  activeCommandLogIndex: null,
  activeAnnotationCommandLogIndex: null,
  activeNetworkLogIndex: null,
  activeTab: 'command',
  isChangeFromVideoComp: false,
  isVideoPlaying: false,
  isScrollByLiveCommand: false,
  isTimestampAlreadyActive: false,
  isNetworkTimestampAlreadyActive: false,
  isVideoPlayable: false,
  lastPlayedSecond: 0,
  videoUrl: null,
  commandLogsData: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case COMMAND_LOG_SET_ACTIVE_INDEX: {
      return {
        ...state,
        activeCommandLogIndex: action.result.index,
        isChangeFromVideoComp: action.result.isChangeFromVideoComp,
        isTimestampAlreadyActive:
          action.result.isTimestampAlreadyActive || false,
        activeAnnotationCommandLogIndex:
          action.result.activeAnnotationCommandLogIndex,
      };
    }

    case SET_IS_VIDEO_PLAYING: {
      return {
        ...state,
        isVideoPlaying: action.result,
      };
    }

    case SET_CHANGE_FROM_VIDEO_COMP: {
      return {
        ...state,
        isChangeFromVideoComp: action.result,
      };
    }

    case COMMAND_LOG_SET_VISUAL_DATA: {
      return {
        ...state,
        commandLogsData: action.result,
      };
    }

    case SET_LAST_PLAYED_SECOND: {
      return {
        ...state,
        lastPlayedSecond: action.result,
      };
    }

    case SET_VIDEO_URL: {
      return {
        ...state,
        videoUrl: action.result,
      };
    }

    case NETWORK_LOG_SET_ACTIVE_INDEX: {
      return {
        ...state,
        activeNetworkLogIndex: action.result.index,
        isChangeFromVideoComp: action.result.isChangeFromVideoComp,
        isNetworkTimestampAlreadyActive:
          action.result.isNetworkTimestampAlreadyActive || false,
      };
    }

    case SET_ACTIVE_TAB: {
      return {
        ...state,
        activeTab: action.result,
      };
    }

    case SET_SCREENSHOT_URL_FOR_VIDEO: {
      return {
        ...state,
        screenshotUrlForVideoContainer: action.result.screenshotUrl,
        playVideo: action.result.playVideo,
        isSetFromCommandLogs: action.result.isSetFromCommandLogs,
        hasBreachedScreenshotLimit: action.result.hasBreachedScreenshotLimit,
      };
    }

    case SET_IS_VIDEO_PLAYABLE: {
      return {
        ...state,
        isVideoPlayable: action.result,
      };
    }

    default:
      return state;
  }
}
